<script setup lang="ts">
</script>

<template>
  <div class="wrapper">
    <main>
      <slot />
    </main>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100dvh;
  position: relative;

  main {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    overflow-x: auto;
  }
}
</style>
